<nz-modal
      [(nzVisible)]="isVisibleChangePassword"
      nzTitle="Change Password"
      nzCentered
      (nzOnCancel)="cancelUpdatePassword()"
      [nzFooter]="modalFooter"
      [nzMaskClosable]="false"
    >
        <form nz-form [formGroup]="changePasswordForm" *nzModalContent>
            <!-- <label class="label-text pb-1">Change Password</label> -->
            <nz-form-item>
                <nz-form-control [nzErrorTip]="oldpasswordErrorTpl">
                    <label class="label-text pt">Old password</label>
                    <nz-input-group [nzSuffix]="oldPasswordSuffixTemplate" class="password-input-box">
                        <input class="input-group" autocomplete [type]="passwordVisible ? 'text' : 'password'" nz-input
                            formControlName="oldPassword" />
                        <ng-template #oldpasswordErrorTpl let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter old
                                password</ng-container>
                        </ng-template>
                    </nz-input-group>
                    <ng-template #oldPasswordSuffixTemplate>
                        <span nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                            (click)="passwordVisible = !passwordVisible"></span>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-control [nzErrorTip]="passwordErrorTpl">
                    <label class="label-text">New password</label>
                    <nz-input-group [nzSuffix]="newPasswordSuffixTemplate" class="password-input-box">
                        <input class="input-group" autocomplete [type]="npasswordVisible ? 'text' : 'password'" nz-input
                            formControlName="password" (ngModelChange)="updateConfirmValidator()" autocomplete minlength="6"
                            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W).*$" />
                        <ng-template #passwordErrorTpl let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter new
                                password</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Password must contain at least 6 characters
                            </ng-container>
                            <ng-container  *ngIf="!control.hasError('minlength') && control.hasError('pattern')">Please enter at least 1 uppercase, 1
                                lowercase, 1 digit And 1 special character
                            </ng-container>
                        </ng-template>
                    </nz-input-group>
                    <ng-template #newPasswordSuffixTemplate>
                        <span nz-icon [nzType]="npasswordVisible ? 'eye-invisible' : 'eye'"
                            (click)="npasswordVisible = !npasswordVisible"></span>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-control [nzErrorTip]="cpasswordErrorTpl">
                    <label class="label-text">Confirm password</label>
                    <nz-input-group [nzSuffix]="confirmPasswordSuffixTemplate" class="password-input-box">
                        <input class="input-group" autocomplete [type]="cpasswordVisible ? 'text' : 'password'" nz-input
                            formControlName="confirmPassword" />
                        <ng-template #cpasswordErrorTpl let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter confirm
                                password</ng-container>
                            <ng-container *ngIf="control.hasError('confirm')">Entered password does not match with above
                                password</ng-container>
                        </ng-template>
                    </nz-input-group>
                    <ng-template #confirmPasswordSuffixTemplate>
                        <span nz-icon [nzType]="cpasswordVisible ? 'eye-invisible' : 'eye'"
                            (click)="cpasswordVisible = !cpasswordVisible"></span>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
        </form>
        <ng-template #modalFooter>
            <div class="d-flex justify-content-end">
            <button nz-button nzType="primary" class="medium-btn small-btn width-100 mr-1"
                (click)="updatePassword()" [nzLoading]="isSubmitting">Update</button>
            <button nz-button nzType="default" class="default-btn width-100"
                (click)="cancelUpdatePassword()">Cancel</button>
            </div>
          </ng-template>
    </nz-modal>
